import gql from 'graphql-tag'

export const accountPaidSubscription = gql`
	subscription($userId: ID!) {
		User(filter: {
			mutation_in: [UPDATED]
			updatedFields_contains: "accountPaid"
			node: {
				id: $userId
				accountPaid: true
			}
		}) {
			node {
				id
			}
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/subscriptions/payment.js